import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { concat as _concat, uniq as _uniq, compact as _compact } from 'lodash';
import langs from 'langs';

import { parseQs, stringifyQs } from 'helpers/http';

import ListFilterBody from 'components/layout/list/ListFilterBody';
import ListFilterListEntry from 'components/layout/list/ListFilterListEntry';

class ListFilterLanguage extends React.Component {
  updateLanguage = (e, language) => {
    e.preventDefault();

    const { location, history } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQs({ ...parseQs(location.search), language }),
    });
  };

  getLangs = () => {
    const { user, projectConfig, whiteLabel, myWhiteLabelProject } = this.props;

    let langsList = _concat(user.project_lang.project_languages, projectConfig.data.languages);

    if (whiteLabel.data) {
      langsList = _concat(langsList, whiteLabel.data.languages);
    }

    if (myWhiteLabelProject.data.count) {
      for (let i = 0; i < myWhiteLabelProject.data.list.length; i++) {
        langsList = _concat(langsList, myWhiteLabelProject.data.list[i].languages);
      }
    }

    return _compact(_uniq(langsList));
  };

  render() {
    const {
      intl: { messages },
      location,
    } = this.props;

    const query = parseQs(location.search);
    const isActive = query.language !== undefined;

    return (
      <ListFilterBody
        title={messages.language}
        isActive={isActive}
        paramNames={['language']}
        body={
          <div class="list-view clearfix">
            <ul class="no-border">
              {this.getLangs().map(projectLanguage => {
                const languageLabel = langs.where('1', projectLanguage).local;

                return (
                  <li key={projectLanguage}>
                    <a
                      class="p-t-5 p-b-5 relative"
                      href="#updateLanguage"
                      onClick={e => this.updateLanguage(e, projectLanguage)}
                    >
                      <ListFilterListEntry isChecked={query.language === projectLanguage} label={languageLabel} />
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        }
      />
    );
  }
}
ListFilterLanguage.defaultProps = {
  languages: null,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    projectConfig: state.data.projectConfig,
    whiteLabel: state.data.whiteLabel,
    myWhiteLabelProject: state.list.myWhiteLabelProject,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(ListFilterLanguage)));
